import { Component, Input } from '@angular/core';
import { type ScoreLevel, ScoreLevelHelper } from '@kirigami/domain/analysis-types';
import { ScoreIcons } from '../score-icons/score-icons';

/**
 * Presentational panel for a single piece of analysis feedback.
 */
@Component({
  selector: 'kirigami-answer-feedback',
  standalone: true,
  imports: [ScoreIcons],
  templateUrl: './answer-feedback.html',
  styleUrls: ['./answer-feedback.scss'],
})
export class AnswerFeedbackComponent {
  @Input() score!: number;
  @Input() category!: string;
  @Input() problem!: string;
  @Input() solution!: string;

  getScoreIcon(score: unknown): ScoreLevel {
    return ScoreLevelHelper.fromScore(score);
  }
}
